export default __webpack_public_path__ + "static/media/close-icon.974dcec6.svg";